import { generateClient } from 'aws-amplify/api';
import PropTypes from 'prop-types';
import { createSpkDJTMaterial } from '../../../graphql/custom_mutations';

const client = generateClient();

export const addDJTMaterial = async (props) => {
  if (props) {
    try {
      console.warn('addDJTMaterial props: ', props);

      const response = await client.graphql({
        query: createSpkDJTMaterial,
        variables: { input: props },
      });

      console.warn('addDJTMaterial response: ', response);
      const results = response.data.createSpkDJTMaterialTbl.id;
      console.warn('addDJTMaterial results: ', results);
      return results;
    } catch (err) {
      return 'error addDJTMaterial: ' + err;
    }
  } else {
    return null;
  }
};

addDJTMaterial.propTypes = {
  props: PropTypes.object.isRequired,
};
